
import GameServer from "../../../hall/server/gameserver/game_server";
import ModelData from "../../../public/model_data";
import ModuleBase from "../../../../framework/core/mvvm/module_base"
import PokerTableBaseView from "./poker_table_base_view";
import PokerTableBaseModel from "./poker_table_base_model";
import { ISeatStateData, IRoomInfoData, IUserInfoData, UserInfoData } from "./poker_table_data_interface"

import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import * as ProtoPokerLogin from "../../net/proto/proto_poker_login";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import PokerTableSeatBaseView from "./poker_table_seat_base_view";
import { IPokerFrameData } from "../poker_table_frame/poker_table_frame_interface_data";
import Hall from "../../../hall/module/hall/hall";
import AudioManager from "../../../../manager/audio_manager";
import TimeManager from "../../../../manager/time_manager";
import GoldEntranceModule from "../../../hall/module/goldentrance/hundred/goldentrance";
import UserDataManager from "../../../../manager/user_manager";
import SceneManager from "../../../../manager/scene_manager";
import AppData from "../../../public/const/app_data";
import TableBaseModule from "../table_base/table_base_module";
import DialogTips from "../../../public/module/dialog_tips/dialog_tips";
import LanguageManager from "../../../../manager/language_manager";
import TablePlayerAvatar from "../../components/table_player_avatar";


const { ccclass } = cc._decorator;

enum ChatMsgType {
    voiceMsg = 0,
    shotMsg = 1,
    emojiMsg = 2,
    text = 3,
    gift = 10,
    tmpLeave = 99,
}

@ccclass
export default abstract class PokerTableBaseModule<V extends PokerTableBaseView, M extends PokerTableBaseModel> extends TableBaseModule<V, M>  {

    m_roomInfo: IRoomInfoData = null
    _lastPinTime: number = 0
    protected _gotoOtherGoldInfo: any = null
    protected LastSendChatTime: number = 0
    // protected _chatRecordDataArr: ChatRecordData[] = []
    protected isGoldTable: boolean = false
    protected isMatchTable: boolean = false
    protected isLeaveRoomSuccess: boolean = true
    protected mNeedReconnectServer: boolean = true
    protected m_hasInitedSeatViewPos: boolean = false
    constructor() {
        super()
        this.initModule(null, null, null)
    }

    initModule(viewType, modelType, resPath) {
        this.windowPrefabResPath = resPath;
        this.viewType = viewType;
        this.modelType = modelType;
    }

    //重置module
    resetModule() {
        this.unbindBtnClickEvent()
        this.unscheduleAll()
        this.unregisstEventMsg()
        this.model.clearMsgEvent()
        if (this.view.hasFirstTimeResetSeatViewPos()) {
            this.view.resetView()
        }
    }

    start() {

    }

    //加载预设完成
    onInit(intentData) {
        super.onInit(intentData)
    }

    protected bindBtnClickEvent() {
        let self = this
        this.view.buttonReconnect.node.on('click', function () {
            GameServer.instance.heartbeat_timeout_reconnect()
        }, this)
        this.view.buttonLeave.node.on('click', this.on_click, this)
        this.view.buttonChat.node.on('click', this.on_click, this)
        this.view.buttonInvite.node.on('click', this.on_click, this)
    }

    protected unbindBtnClickEvent() {
        if(!this.view){
            return
        }
        this.view.buttonReconnect.node.targetOff(this)
        this.view.buttonLeave.node.targetOff(this)
        this.view.buttonChat.node.targetOff(this)
        this.view.buttonInvite.node.targetOff(this)
    }

    closeServerConnect(needReconnectServer?: boolean) {
        this.mNeedReconnectServer = needReconnectServer || false
        GameServer.instance.close()
    }

    private pingCheck() {
        let curTime = Date.now()
        let dif = (curTime - this._lastPinTime) / 1000
        if (this._lastPinTime > 0 && dif >= 15 && GameServer.instance.netClient.netState) {//超时
            this.unscheduleAll()
            cc.warn("ping 超时，主动断开连接！")
            GameServer.instance.heartbeat_timeout_reconnect()
        }
    }

    private pingCallback() {
        if (GameServer.instance.netClient.netState && this.view && this.view.nodeIsValid) {
            // GameServer.instance.requestPing();
        }
        else {
            this.unscheduleAllCallbacks()
        }
    }

    private unscheduleAll() {
        this.unschedule(this.pingCallback)
        this.unschedule(this.pingCheck)
        if (this.view && this.view.nodeIsValid) {
            this.view.unscheduleAll()
        }
    }

    //调用show时
    onShow(intentData) {
        ModuleManager.instance.hideModule("NetPrompt")
        this._lastPinTime = 0
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        super.onShow(intentData);
        
        this.bindBtnClickEvent()

        this.registNetMsg()

        this.isLeaveRoomSuccess = false
        this.view.showWaitMatchAnim(false)
        this.playFightMusic()
    }

    onHide() {
        super.onHide()
        this.unbindBtnClickEvent()
        this.model && this.model.clearMsgEvent()
        ModuleManager.instance.hideModule("TableChat")
    }

    on_destroy() {
        super.on_destroy()
        this.unbindBtnClickEvent()
        this.model && this.model.clearMsgEvent()
        ModuleManager.instance.hideModule("TableChat")
    }

    protected initSeatViewPos(){
        if(this.m_hasInitedSeatViewPos){
            return
        }
        this.m_hasInitedSeatViewPos = true
        let ruleTable = this.getRemoteRule()
        if (this.view.hasFirstTimeResetSeatViewPos()) {
            this.view.resetView()
        }
        this.view.setSeatCount(ruleTable.playerCount)
        this.view.resetSeatViewPos()
        this.pingCallback()
        this.schedule(this.pingCallback, 4)
        this.schedule(this.pingCheck, 1)
    }

    protected getServerNowTimestamp(): number {
        let roomInfo = this.getRoomInfo()
        return roomInfo.timeOffset + Utility.nowTimestamp()
    }

    protected onApplicationShow(isShow) {
        if (!this || !this.nodeIsValid || !this.view || !this.view.nodeIsValid) {
            return
        }
        //cc.log("onApplicationShow>>> poker_table_base_module")

        if (isShow) {//切換到前台
            if (!GameServer.instance.netClient.netState) {
                if (this.mNeedReconnectServer) {
                    cc.warn("游戏服重连！")
                    GameServer.instance.reconnectServer()
                }
            }
        } else {

        }
    }

    setRoomInfo(roomInfo: IRoomInfoData) {
        this.m_roomInfo = roomInfo
    }

    getRoomInfo<T extends IRoomInfoData>(): T {
        return this.m_roomInfo as T
    }

    getRemoteRule(): any {
        return ModelData.instance.roomInfo.PlayRuleData
    }

    getSeatInfoByPlayerId<T extends ISeatStateData>(playerId: number): T {
        let seatInfoList = this.m_roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index];
            if (element.playerId == playerId) {
                return element as T
            }
        }
        return null
    }

    getSeatInfoByRemotePos(remotePos: number): ISeatStateData {
        let seatInfoList = this.m_roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index];
            if (element.remotePos == remotePos) {
                return element
            }
        }
        return null
    }

    getSeatInfoByLocalPos(localPos: number): ISeatStateData {
        let seatInfoList = this.m_roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index];
            if (element.localPos == localPos) {
                return element
            }
        }
        return null
    }


    getLocalPosFromRemotePos(remotePos: number, firstViewPos: number, seatCount: number) {
        let localPos = remotePos + (1 - firstViewPos) + seatCount
        if (localPos > seatCount) {
            return localPos - seatCount - 1
        } else {
            return localPos - 1
        }
    }

    abstract genSeatInfo(playerId): ISeatStateData
    genUserInfo(data): IUserInfoData {
        return new UserInfoData(data)
    }

    genFreeRoomData(protoData: ProtoPokerRoom.Room.FreeBroadcast): any {
        let self = this
        let freeRoomStateList = []
        let roomInfo = this.getRoomInfo()
        let mySeatInfo = roomInfo.mySeatInfo
        let seatInfoList = roomInfo.seatInfoList
        let sponsor
        let isFree = seatInfoList.length == protoData.freeRoomStateList.length
        let disAgreePlayerId = null
        for (let i = 0; i < seatInfoList.length; i++) {
            const seatInfo = seatInfoList[i];
            let tmpFreeRoomState
            for (let j = 0; j < protoData.freeRoomStateList.length; j++) {
                const element = protoData.freeRoomStateList[j];
                if (element.playerId == seatInfo.playerId) {
                    tmpFreeRoomState = element
                }
                sponsor = element.sponsor
            }
            let headImgSpriteFrame = null
            if (seatInfo.userInfo) {
                headImgSpriteFrame = PokerTableSeatBaseView.s_avatarSpriteCacheManager.findSpriteFrame(seatInfo.userInfo.headImg)
            }
            let freeRoomState = {
                playerId: seatInfo.playerId,
                agree: tmpFreeRoomState ? tmpFreeRoomState.agree : false,
                disAgree: tmpFreeRoomState ? (!tmpFreeRoomState.agree) : false,
                userInfo: seatInfo.userInfo ? seatInfo.userInfo : null,
                headImgSpriteFrame: headImgSpriteFrame,
            }
            if (freeRoomState.disAgree) {
                isFree = false
            }
            if (freeRoomState.disAgree) {
                disAgreePlayerId = freeRoomState.playerId
            }
            freeRoomStateList.push(freeRoomState)
        }
        let data = {
            freeRoomStateList: freeRoomStateList,
            myPlayerId: mySeatInfo.playerId,
            sponsor: sponsor,
            leftSecs: protoData.expire - self.getServerNowTimestamp(),
            getUserMessage: self.view.getUserMessage.bind(self.view),
            agreeCallback: function () {
                self.model.send_dissolve_request(true)
            },
            disAgreeCallback: function () {
                self.model.send_dissolve_request(false)
            },
            isFree: isFree,
            disAgreePlayerId: disAgreePlayerId,
        }
        return data
    }

    onLeaveRoomSuccess(isKick?: boolean) {
        //断开连接
        this.closeServerConnect()
        this.isLeaveRoomSuccess = true
        if (this.getIsGoldTable()) {
            if (isKick) {
                return
            }
            if (this._gotoOtherGoldInfo) {
                this.start_gold_matching()
                return
            }
            ModuleManager.instance.hideModule('PokerGoldOneGameResultModule')
        }
        //回到大厅界面
        ModuleManager.instance.hideModule(this.moduleName)
        SceneManager.showHall()
        if (this.getIsGoldTable()) {
            ModuleManager.instance.showModule(GoldEntranceModule)
        }
    }

    protected registEventMsg() {
        super.registEventMsg()
        this.eventBind("tablechat_sendcontent", this.sendChat)
        this.eventBind("Table_Gold_Enough", this.onRechargeComplete)
        this.eventBind("game_event_show", this.onApplicationShow)
        this.eventBind("Table_Refresh_Coin", this.refreshMyUserData)
        this.eventBind("tablechat_sendMagicEmoj", this.send_magic_emoji)
    }

    protected unregisstEventMsg() {
        super.unregisstEventMsg()
        this.eventUnBind("tablechat_sendcontent", this.sendChat)
        this.eventUnBind("Table_Gold_Enough", this.onRechargeComplete)
        this.eventUnBind("game_event_show", this.onApplicationShow)
        this.eventUnBind("Table_Refresh_Coin", this.refreshMyUserData)
        this.eventUnBind("tablechat_sendMagicEmoj", this.send_magic_emoji)
    }

    protected registNetMsg() {
        
    }

    protected onNetMsg_PingRsp(protoData: ProtoPokerLogin.Login.PingRsp) {
        this._lastPinTime = Date.now()
    }

    protected onNetMsg_ReadyRsp(protoData: ProtoPokerRoom.Room.ReadyRsp) {
        if (protoData.errNo == '0') {
            let mySeatInfo = this.m_roomInfo.mySeatInfo
            mySeatInfo.isReady = true
            this.view.showSeatReady(mySeatInfo.localPos, true)
            this.view.showReadyBtn(false)
        } else {
            ModuleManager.instance.toast(protoData.errNo)
        }
    }

    protected onNetMsg_ReadyNotify(protoData: ProtoPokerRoom.Room.ReadyBroadcast) {
        let seatInfo = this.getSeatInfoByPlayerId(protoData.posInfo.playerId)
        seatInfo.isReady = protoData.posInfo.isReady == 1
        this.view.showSeatReady(seatInfo.localPos, seatInfo.isReady)
    }

    protected onNetMsg_EnterRsp(protoData: ProtoPokerRoom.Room.EnterRsp) {
        let ruleTable = this.getRemoteRule()
        if(!ruleTable){
            return
        }
        if (ruleTable.VoiceChatForbidden) {
            this.view.showChatBtn(false)
            this.view.showMicBtn(false)
        }
    }

    protected onNetMsg_EnterNotify(protoData: ProtoPokerRoom.Room.EnterBroadcast) {
        let self = this
        let mySeatInfo = self.m_roomInfo.mySeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.posInfo.posIndex)
        seatInfo.playerId = protoData.posInfo.playerId
        seatInfo.isReady = protoData.posInfo.isReady == 1
        seatInfo.isOffLine = false
        seatInfo.isTmpLeave = false
        seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, protoData.posInfo.coinBalance)
        UserDataManager.setUserJsonData(protoData.userJson)
        self.view.showSeatInfo(seatInfo.localPos, seatInfo.playerId, function (userInfoData) {
            seatInfo.userInfo = self.genUserInfo(userInfoData)
            self.tryRefreshAllChatRecordData()
        })
    }

    protected onNetMsg_StartRsp(protoData: ProtoPokerRoom.Room.StartRsp) {
        if (protoData.errNo == '0') {
            this.view.showStartBtn(false)
        } else {
            ModuleManager.instance.toast(protoData.errNo)
        }
    }

    protected onNetMsg_StartNotify(protoData: ProtoPokerRoom.Room.StartBroadcast) {
        if (protoData.errNo != '0') {
            ModuleManager.instance.toast(protoData.errNo)
        }
        this.view.showStartBtn(false)
    }

    protected onNetMsg_LeaveRsp(protoData: ProtoPokerRoom.Room.LeaveRsp) {
        if (protoData.errNo == '0') {
            this.onLeaveRoomSuccess()
        } else {
            ModuleManager.instance.toast(protoData.errNo)
        }
    }

    protected onNetMsg_LeaveNotify(protoData: ProtoPokerRoom.Room.LeaveBroadcast) {
        let mySeatInfo = this.getRoomInfo().mySeatInfo
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo == null) {
            return
        }
        if (mySeatInfo.playerId == seatInfo.playerId) {
            
            this.onLeaveRoomSuccess(true)
            let key = "server_error_" + protoData.reason
            let content = LanguageManager.t(key, true)
            if(key != content){
                ModuleManager.instance.showModule(DialogTips, { Content: content, titleError : true })
            }            
            return
        }
        seatInfo.playerId = 0
        this.view.showSeatInfo(seatInfo.localPos, seatInfo.playerId)
        seatInfo.reset()
    }

    protected onNetMsg_ChatRsp(protoData: ProtoPokerRoom.Room.ChatMsgRsp) {

    }

    protected onNetMsg_ChatNotify(protoData: ProtoPokerRoom.Room.ChatMsgBroadcast) {
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo) {
            let chatMsg = protoData.chatMsg
            let data: any = {}
            data["chatContent"] = chatMsg.text
            switch (chatMsg.msgType) {
                case ChatMsgType.text:
                    data["chatType"] = 0
                    data["Dir"] = this.getSeatChatTextDir(seatInfo.localPos)
                    data["WorldPos"] = this.getSeatChatTextPos(seatInfo.localPos)
                    this.addChatRecordData(seatInfo, chatMsg.text)
                    // EventManager.instance.dispatch('Event_Barrage_Data', {dir: data.Dir, content: data.chatContent})
                    // return
                    break
                case ChatMsgType.shotMsg:
                    let text = this.getShotMsgByKey(chatMsg.text)
                    if (!text || text == '') {
                        return
                    }
                    this.playShortMsgSound(seatInfo.userInfo && seatInfo.userInfo.gender == 1, chatMsg.text)
                    data["chatType"] = 0
                    data["chatContent"] = text
                    data["Dir"] = this.getSeatChatTextDir(seatInfo.localPos)
                    data["WorldPos"] = this.getSeatChatTextPos(seatInfo.localPos)
                    this.addChatRecordData(seatInfo, text)
                    // EventManager.instance.dispatch('Event_Barrage_Data', {dir: data.Dir, content: data.chatContent})
                    // return
                    break
                case ChatMsgType.voiceMsg:

                    return;
                case ChatMsgType.gift:
                    let gift = JSON.parse(chatMsg.text)
                    this.play_magic_emoji(gift, seatInfo.localPos)
                    return;
                case ChatMsgType.tmpLeave:
                    let leaveData = {
                        playerId: protoData.playerId,
                        isTempLeave: chatMsg.text == 'leave',
                    }
                    this.onNetMsgTmpLeaveNotify(leaveData)
                    return;
                case ChatMsgType.emojiMsg:
                    data["chatType"] = 1
                    data["chatContent"] = Number(chatMsg.text)
                    data["WorldPos"] = this.getSeatEmojiPos(seatInfo.localPos)
                    break;

                default:
                    return;
            }
            // ModuleManager.instance.showModule(ChatShow, "ChatShow", data)
        }
    }

    protected play_magic_emoji(gift, senderLocalPos) {
        let seatInfo = this.getSeatInfoByPlayerId(gift.receiver)
        let from_pos = this.getSeatEmojiPos(senderLocalPos)
        let to_pos = this.getSeatEmojiPos(seatInfo.localPos)
        //type:0鲜花，1鸡蛋，2干杯， 3扔鞋
        //开始点和结束点 可传入Vec或者node
        // ModuleManager.instance.showModule(MagicEmojModule, "MagicEmojModule", { type: gift.giftName, fromPos: from_pos, toPos: to_pos })
    }

    protected onNetMsgTmpLeaveNotify(protoData: { playerId: number, isTempLeave: boolean }) {
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo) {
            seatInfo.isTmpLeave = protoData.isTempLeave
            this.view.showSeatTmpLeaveTag(seatInfo.localPos, seatInfo.isTmpLeave)
        }
    }

    protected onNetMsg_DissolveRsp(protoData: ProtoPokerRoom.Room.FreeRsp) {

    }

    protected onNetMsg_DissolveNotify(protoData: ProtoPokerRoom.Room.FreeBroadcast) {
        let freeRoomData = this.genFreeRoomData(protoData)
        //显示解散界面
        if (freeRoomData.isFree || freeRoomData.disAgreePlayerId) {
            ModuleManager.instance.hideModule('PokerDissolveRoom')
        } else {
            // ModuleManager.instance.showModule(PokerDissolveRoom, 'PokerDissolveRoom', freeRoomData)
        }
    }

    protected onNetMsg_DissolveSuccessNotify(protoData: ProtoPokerRoom.Room.FreeSuccessBroadcast) {
        ModuleManager.instance.hideModule('PokerDissolveRoom')
        this.onLeaveRoomSuccess()
    }

    protected onNetMsg_DisconnectNotify(protoData: ProtoPokerRoom.Room.DisconnBroadcast) {
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo) {
            seatInfo.isOffLine = true
            seatInfo.isTmpLeave = false
            this.view.showSeatOffLineTag(seatInfo.localPos, true)
            this.view.showSeatTmpLeaveTag(seatInfo.localPos, false)
        }
    }

    protected onNetMsg_ReconnectNotify(protoData: ProtoPokerRoom.Room.ReconnBroadcast) {
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        seatInfo.isOffLine = false
        seatInfo.isTmpLeave = false
        this.view.showSeatOffLineTag(seatInfo.localPos, false)
        this.view.showSeatTmpLeaveTag(seatInfo.localPos, false)
    }

    protected onNetMsg_ResetNotify(protoData: ProtoPokerRoom.Room.ResetBroadcast) {

    }

    protected onNetMsg_CustomInfoChangeRsp(protoData: ProtoPokerRoom.Room.CustomInfoChangeRsp) {

    }

    protected onNetMsg_CustomInfoChangeNotify(protoData: ProtoPokerRoom.Room.CustomInfoChangeBroadcast) {

    }

    protected onNetMsg_KickPlayerRsp(protoData: ProtoPokerRoom.Room.KickPlayerRsp) {

    }

    protected onNetMsg_KickPlayerNotify(protoData: ProtoPokerRoom.Room.KickPlayerBroadcast) {
        let mySeatInfo = this.getRoomInfo().mySeatInfo
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo == null) {
            return
        }
        if (mySeatInfo.playerId == seatInfo.playerId) {
            this.onLeaveRoomSuccess(true)
            return
        }
        this.view.showSeatInfo(seatInfo.localPos, seatInfo.playerId)
        seatInfo.reset()
    }

    protected onNetMsg_OneShotSettleNotify(protoData: ProtoPokerRoom.Room.OneShotSettleNotify) {

    }

    protected onNetMsg_IntrustRsp(protoData: ProtoPokerRoom.Room.IntrustRsp) {

    }

    protected onNetMsg_IntrustNotify(protoData: ProtoPokerRoom.Room.IntrustNotify) {

    }

    protected onNetMsg_RechargeNotify(protoData: ProtoPokerRoom.Room.RechargeNotify) {

    }

    protected sendChat(type, content) {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2.6 > AppRunningTime) {
            ModuleManager.instance.toast("对话过于频繁,歇息一会再发吧")
            return
        }
        this.LastSendChatTime = AppRunningTime
        //type: 0:系统文本对话  1:表情对话  2:自己输入的文本 //content :系统文本对话或者表情id或者自己输入的文本的内容
        let chatMsgType = ChatMsgType.shotMsg
        switch (type) {
            case 0:
                chatMsgType = ChatMsgType.shotMsg
                break;
            case 1:
                chatMsgType = ChatMsgType.emojiMsg
                break;
            case 2:
                chatMsgType = ChatMsgType.text
                break;
        }
        this.model.send_chat_request(chatMsgType, content)
    }

    protected onRechargeComplete(enough, restCoin) {
        let self = this
        if (this.nodeIsValid && this.view && this.view.nodeIsValid && this.view.node.activeInHierarchy) {
            if (!enough) {
                ModuleManager.instance.toast("您的金币不足，将自动返回大厅！")
                if (this.getIsLeaveSuccess()) {
                    ModuleManager.instance.hideAllModule()
                    SceneManager.showHall()
                    ModuleManager.instance.showModule(GoldEntranceModule)
                } else {
                    this.model.send_leave_request()
                }
            } else {
                this.changeTable(null)
            }
        }
    }

    protected on_click(event: cc.Button): boolean {
        let isClickValid = Utility.btnClickValid()
        if (!isClickValid) {
            return isClickValid
        }
        Utility.playButtonSound()
        let node: cc.Node = event.node
        if (node == this.view.buttonLeave.node) {
            this.on_click_leave_btn()
        } else if (node == this.view.buttonChat.node) {
            this.on_click_chat_btn()
        } else if (node == this.view.buttonInvite.node) {
            this.on_click_invite_btn()
        }
        return isClickValid
    }

    protected on_click_invite_btn() {
        let self = this
        let roomInfo = self.getRoomInfo()
        if (!roomInfo) {
            return
        }
        let inRoomPlayerCount = 0
        for (let i = 0; i < roomInfo.seatInfoList.length; i++) {
            const seatInfo = roomInfo.seatInfoList[i]
            if (seatInfo.playerId != 0) {
                inRoomPlayerCount++
            }
        }
        let cur = inRoomPlayerCount
        let need = roomInfo.playerCount - cur
        let title = "有人@你-" + roomInfo.roomId + " " + cur + "缺" + need
        // WXGameManager.shareByConfig(MakePointType.SHARE_FRIEND_INVITE, 0, query, title)
    }

    on_click_leave_btn() {
        let roomInfo = this.getRoomInfo()
        let mySeatInfo = roomInfo.mySeatInfo
        if (!roomInfo.isGoldTable && mySeatInfo.isOwner) {
            this.model.send_dissolve_request(true)
        } else if (roomInfo.isGoldTable || roomInfo.curRoundNum == 0) {
            this.model.send_leave_request()
        } else {
            this.model.send_dissolve_request(true)
        }
    }

    protected on_click_chat_btn() {
        // ModuleManager.instance.showModule(TableChat, "TableChat", this.getShowTableChatData())
    }

    protected getShowTableChatData() {
        let data = {}
        let hideType = 0
        if (this.getIsGoldTable()) {
            hideType = 1
        }
        data["hideType"] = hideType
        data["IsImmediatelyHide"] = false
        // data['chatTextList'] = PokerTableChatData.ChatTextList
        return data
    }

    getPokerFrameData(roomId: number) {
        let self = this
        let data: IPokerFrameData = {
            roomId: roomId,
            showRoomInfo: true,
            showTime: true,
            showSettingBtn: true,
            clickLeaveBtnCallback: function () {
                self.on_click_leave_btn()
            },
            clickFreeRoomBtnCallback: function () {
                self.on_click_leave_btn()
            },
            clickSettingBtnCallback: function () {
                ModuleManager.instance.showModuleName("Setting");
            }
        }
        return data
    }

    getMenuTableIntentData(): any {
        let self = this
        let data = {
            showSettingBtn: true,
            onClickLeaveBtnCallback: function () {
                self.on_click_leave_btn()
            },
            onClickFreeRoomBtnCallback: function () {
                self.on_click_leave_btn()
            },
            onClickSettingBtnCallback: function () {
                ModuleManager.instance.showModuleName("Setting");
            },
            showRuleBtn: true,
            onClickRuleBtnCallback: function () {
                ModuleManager.instance.showModuleName("PublicRule");
            },
        }
        return data
    }

    protected getShotMsgByKey(key: string): string {
        // return PokerTableChatData.ChatTextList[key]
        return ""
    }

    protected getShotMsgSoundPath(key: string, male: boolean): string {
        let sex = male ? "male_" : 'female_'
        let soundname = "chat_" + sex + key
        let path = "sound/tablechat/" + soundname
        return path
    }

    protected getSeatChatTextPos(localPos: number) {
        let seatView = this.view.getSeatViewByPos(localPos)
        return seatView.getChatTextWorldPos()
    }

    protected getSeatChatTextDir(localPos: number): number {
        let seatView = this.view.getSeatViewByPos(localPos)
        return seatView.getChatTextDir()
    }

    protected getSeatEmojiPos(localPos: number) {
        let seatView = this.view.getSeatViewByPos(localPos)
        return seatView.getChatEmojiWorldPos()
    }

    addChatRecordData(seatInfo: ISeatStateData, chatContent: string) {
        let NickName = null
        let headImgSpriteFrame = null
        if (seatInfo.userInfo) {
            NickName = Utility.filterPlayerName(seatInfo.userInfo.nickname)
            headImgSpriteFrame = PokerTableSeatBaseView.s_avatarSpriteCacheManager.findSpriteFrame(seatInfo.userInfo.headImg)
        }
        // let data: ChatRecordData = new ChatRecordData(seatInfo.playerId, NickName, headImgSpriteFrame, chatContent, Number(ModelData.instance.roleData.id))
        // let index = this._chatRecordDataArr.length
        // this._chatRecordDataArr[index] = data
        this.tryRefreshAllChatRecordData()
    }

    tryRefreshAllChatRecordData() {
        let isAllOk = true
        // for (let i = 0; i < this._chatRecordDataArr.length; i++) {
        //     const element = this._chatRecordDataArr[i];
        //     let seatInfo = this.getSeatInfoByPlayerId(element.playerId)
        //     if (!element.playerName) {
        //         if (seatInfo && seatInfo.userInfo) {
        //             element.playerName = Utility.filterPlayerName(seatInfo.userInfo.nickname)
        //         } else {
        //             isAllOk = false
        //         }
        //     }
        //     if (!element.playerHeadSprite) {
        //         let seatInfo = this.getSeatInfoByPlayerId(element.playerId)
        //         if (seatInfo) {
        //             element.playerHeadSprite = PokerTableSeatBaseView.s_avatarSpriteCacheManager.findSpriteFrame(seatInfo.userInfo.headImg)
        //         }
        //     }
        // }
        if (!isAllOk) {
            return isAllOk
        }
        // EventManager.instance.dispatch("tablechat_RefreshRecord", this._chatRecordDataArr)
        return isAllOk
    }

    //金币场换桌
    changeTable(onSuccuess) {
        let myGold = ModelData.instance.roleData.gold
        let goldId = ModelData.instance.tableCommonData.goldFildId
        let self = this
        // MatchingManager.instance.getGoldById(goldId, (data) => {
        //     if (!self || !self.isValid || !self.view || !self.view.isValid) {
        //         cc.log("changeTable has error", new Error().stack)
        //         return
        //     }
        //     self._gotoOtherGoldInfo = data
        //     if (self.getIsLeaveSuccess()) {
        //         self.start_gold_matching()
        //     } else {
        //         self.model.send_leave_request()
        //     }
        //     onSuccuess && onSuccuess()
        // })
    }

    setIsGoldTable(isGoldTable: boolean) {
        this.isGoldTable = isGoldTable
    }

    setIsMatchTable(isMatchTable: boolean) {
        this.isMatchTable = isMatchTable
    }

    getIsGoldTable(): boolean {
        return this.isGoldTable
    }

    getIsMatchTable(): boolean {
        return this.isMatchTable
    }

    getIsLeaveSuccess() {
        return this.isLeaveRoomSuccess
    }

    start_gold_matching() {
        let self = this;
        // MatchingManager.instance.get_quickJoin_data(GoldTagCode.Classic, function (data) {
        //     MatchingManager.instance.gold_jump_deal(self._gotoOtherGoldInfo, data, ModelData.instance.tableCommonData.qualifyId, true);
        //     self._gotoOtherGoldInfo = null
        // }, function (err) {
        //     self.start_gold_matching();
        // });

    }

    refreshMyGold(gold: number) {
        ModelData.instance.roleData.gold = gold
    }

    isLastRoundInCurLoop(): boolean {
        return false
    }

    getMatchById(matchId: number, stageNum: number, complete: Function) {
        // ModuleData.instance.getMatchData(matchId, stageNum, complete)
    }

    goToMatching(matchId, stageId) {
        let id = ModelData.instance.roleData.id
        let password = ModelData.instance.password
        // HallServer.instance.accountLogin(id, password, "", function (protoData) {
        //     HallServer.instance.request_matching_enter(matchId, stageId, id)
        // })
    }

    protected playFightMusic() {
        AudioManager.instance.playFightMusic()
    }

    //刷新自己的金币信息
    protected refreshMyUserData() {
        let self = this
        // MatchingManager.instance.getUserNewMessage(() => {
        //     if (self && self.isValid) {
        //         self.refreshMyCoinBalance(ModelData.instance.roleData.gold)
        //     }
        // }, true)
    }

    protected send_magic_emoji(emojiId, receiverId) {
        let gift = {
            receiver: receiverId,
            giftName: emojiId,
            times: 1,
        }
        this.model.send_chat_request(ChatMsgType.gift, JSON.stringify(gift))
    }

    protected abstract refreshMyCoinBalance(gold: number);

    protected playShortMsgSound(male: boolean, key: string) {
        let soundPath = this.getShotMsgSoundPath(key, male)
        if (soundPath && soundPath != '') {
            AudioManager.instance.playSound(soundPath)
        }
    }

    protected on_click_player_avatar(avatar: TablePlayerAvatar){
        let seatInfo = this.getSeatInfoByPlayerId(avatar.uid)
        let gold = null
        let chip = null
        //删除isMangoTable的判断  modif by dred 
        // if(ModelData.instance.tableCommonData.isMangoTable){
        //     gold = seatInfo['coinBalance']
        // }else{
        //     chip = seatInfo['coinBalance']
        // }
        chip = seatInfo['coinBalance']
        ModuleManager.instance.showEmojiModule(avatar.uid, this.moduleName, gold, chip)
    }

    getSeatNodeById(playerId: number): cc.Node{
        let seatInfo = this.getSeatInfoByPlayerId(playerId)
        if(seatInfo){
            let seatView = this.view.getSeatViewByPos(seatInfo.localPos)
            if(seatView){
                return seatView.nodeChatEmoji
            }
        }        
        return null
    }
}